import { ICON_TYPES } from './iconTypes';

export default {
	googlePlaystore: {
		name: 'logo-google-playstore',
		type: ICON_TYPES.ionicon,
		text: 'Playstore',
	},
	appleAppstore: {
		name: 'ios-logo-apple-appstore',
		type: ICON_TYPES.ionicon,
		text: 'Appstore',
	},
};